import { Modal } from '../ui/Modal';
import { Phone, PhoneOff } from 'lucide-react';

interface EmergencyCallModalProps {
  isOpen: boolean;
  onClose: () => void;
  driverName: string;
  driverPhone?: string;
  vehiclePlate?: string;
}

// issue #152: esto simulaba una llamada VoIP completa (dialing → connected →
// timer, mute) sin backend ni proveedor real detrás — nada de eso ocurría de
// verdad. La decisión (acta Mindor Dev Team, 2026-09-14) fue no construir VoIP
// ahora: en mobile, "llamar" es delegar al marcador nativo del teléfono con un
// enlace tel:, igual que ya hace DriverProfileModal (#121). Sin backend nuevo.
export function EmergencyCallModal({ isOpen, onClose, driverName, driverPhone, vehiclePlate }: EmergencyCallModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="📞 Llamada directa" size="sm">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: '1.25rem', padding: '1rem 0' }}>

        <div style={{
          width: '80px', height: '80px', borderRadius: '50%',
          background: 'linear-gradient(135deg, #EF4444, #DC2626)',
          color: '#FFF', display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '28px', fontWeight: 800, boxShadow: '0 8px 24px rgba(0,0,0,0.3)'
        }}>
          {driverName.charAt(0)}
        </div>

        <div>
          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 800, color: 'var(--text-primary)' }}>{driverName}</h3>
          <p style={{ margin: 0, fontSize: '13px', color: 'var(--text-muted)', marginTop: '2px' }}>
            {vehiclePlate ? `Vehículo: ${vehiclePlate}` : 'Operador Flota'}
          </p>
        </div>

        {driverPhone ? (
          <a
            href={`tel:${driverPhone}`}
            onClick={onClose}
            style={{
              display: 'flex', alignItems: 'center', gap: '0.5rem',
              background: '#10B981', color: '#FFF', border: 'none', borderRadius: '999px',
              padding: '0.75rem 1.5rem', fontSize: '15px', fontWeight: 700,
              textDecoration: 'none', boxShadow: '0 4px 16px rgba(16,185,129,0.35)'
            }}
          >
            <Phone size={18} /> Llamar a {driverPhone}
          </a>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.4rem', color: 'var(--text-muted)' }}>
            <PhoneOff size={20} />
            <p style={{ margin: 0, fontSize: '13px' }}>Sin teléfono registrado — no se puede iniciar la llamada.</p>
          </div>
        )}

      </div>
    </Modal>
  );
}
